// FIXME: Update this file to be type safe and remove this and next line
// @ts-strict-ignore
import { CommonModule } from "@angular/common";
import { Component, OnInit, signal, Signal , inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { RouterModule } from "@angular/router";
import { combineLatest, map, Observable, of, switchMap } from "rxjs";

import { JslibModule } from "@bitwarden/angular/jslib.module";
import { PasswordManagerLogo , PasswordManagerLogoFr } from "@bitwarden/assets/svg";
import { PolicyService } from "@bitwarden/common/admin-console/abstractions/policy/policy.service.abstraction";
import { PolicyType } from "@bitwarden/common/admin-console/enums";
import { AccountService } from "@bitwarden/common/auth/abstractions/account.service";
import { getUserId } from "@bitwarden/common/auth/services/account.service";
import { BillingAccountProfileStateService } from "@bitwarden/common/billing/abstractions/account/billing-account-profile-state.service";
import { FeatureFlag } from "@bitwarden/common/enums/feature-flag.enum";
import { ConfigService } from "@bitwarden/common/platform/abstractions/config/config.service";
import { I18nService } from "@bitwarden/common/platform/abstractions/i18n.service";
import { SyncService } from "@bitwarden/common/platform/sync";
import { IconModule } from "@bitwarden/components";

import { BillingFreeFamiliesNavItemComponent } from "../billing/shared/billing-free-families-nav-item.component";

import { WebLayoutModule } from "./web-layout.module";

// FIXME(https://bitwarden.atlassian.net/browse/CL-764): Migrate to OnPush
// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: "app-user-layout",
  templateUrl: "user-layout.component.html",
  imports: [
    CommonModule,
    RouterModule,
    JslibModule,
    WebLayoutModule,
    IconModule,
    BillingFreeFamiliesNavItemComponent,
  ],
})
export class UserLayoutComponent implements OnInit {
  protected logo = PasswordManagerLogo;
  protected readonly showEmergencyAccess: Signal<boolean>;
  protected hasFamilySponsorshipAvailable$: Observable<boolean>;
  protected showSponsoredFamilies$: Observable<boolean>;
  protected showSubscription$: Observable<boolean>;
  protected consolidatedSessionTimeoutComponent$: Observable<boolean>;
  private i18nService = inject(I18nService);
  constructor(
    private syncService: SyncService,
    private billingAccountProfileStateService: BillingAccountProfileStateService,
    private accountService: AccountService,
    private policyService: PolicyService,
    private configService: ConfigService,
  ) {
    // SLG Comment : Remove Subscription and Emergency Access
    this.showSubscription$ = of(false);
    // this.accountService.activeAccount$.pipe(
    //   switchMap((account) =>
    //     this.billingAccountProfileStateService.canViewSubscription$(account.id),
    //   ),
    // );

    this.showEmergencyAccess = signal(false);
    // toSignal(
    //   combineLatest([
    //     this.configService.getFeatureFlag$(FeatureFlag.AutoConfirm),
    //     this.accountService.activeAccount$.pipe(
    //       getUserId,
    //       switchMap((userId) =>
    //         this.policyService.policyAppliesToUser$(PolicyType.AutoConfirm, userId),
    //       ),
    //     ),
    //   ]).pipe(
    //     map(([enabled, policyAppliesToUser]) => {
    //       if (!enabled || !policyAppliesToUser) {
    //         return true;
    //       }
    //       return false;
    //     }),
    //   ),
    // );

    this.consolidatedSessionTimeoutComponent$ = this.configService.getFeatureFlag$(
      FeatureFlag.ConsolidatedSessionTimeoutComponent,
    );
  }

  async ngOnInit() {
    document.body.classList.remove("layout_frontend");
    const lang = this.i18nService.translationLocale;
    if (lang === "fr") {
      this.logo = PasswordManagerLogoFr;
    } else {
      this.logo = PasswordManagerLogo;
    }
    await this.syncService.fullSync(false);
  }
}
